import { render, staticRenderFns } from "./AutomaticSentence.vue?vue&type=template&id=1db46084"
import script from "./AutomaticSentence.vue?vue&type=script&lang=js"
export * from "./AutomaticSentence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports